import { render, staticRenderFns } from "./role-permission.vue?vue&type=template&id=00fbd37c&scoped=true&"
import script from "./role-permission.vue?vue&type=script&lang=js&"
export * from "./role-permission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fbd37c",
  null
  
)

export default component.exports